/** @module Enums */ /** typedoc */

export enum DiscountTypeEnum {
    Percentage = 'Percentage',
    Amount = 'Amount',
    AmountPerUnit = 'AmountPerUnit',
}
